import React, {ReactNode, Suspense} from 'react';
import styled from 'styled-components';

import {Loader} from '../../libs/shared/ui/src/components/loaders/loader';
import {VisualSizesEnum} from '../../libs/shared/ui/src/styles/commonStyles';

const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const wrapWithSuspense = (component: ReactNode | null) =>
  component && (
    <Suspense
      fallback={
        <StyledLoaderWrapper>
          <Loader size={VisualSizesEnum.LARGE} />
        </StyledLoaderWrapper>
      }
    >
      {component}
    </Suspense>
  );
